// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    appVersion: require('../../package.json').version,
    production: false,
    isFormPreview: false,
    // siteBaseUrl: "https://compliancegenieprod-staging.azurewebsites.net",
    //siteBaseUrl: "https://cg-dev-test.azurewebsites.net",
    //siteBaseUrl: "https://cg-demo-test.azurewebsites.net",
    //siteBaseUrl: "https://demo.besafe-tech.com",
    //siteBaseUrl: "https://cg-dev-test-staging.azurewebsites.net",
    // siteBaseUrl: "https://cg1-manager.azurewebsites.net"
    //siteBaseUrl: "http://localhost:51844"
    // siteBaseUrl: "https://login.be-safetech.com"
    // siteBaseUrl: "https://cg-dev-test-mm2.azurewebsites.net"
    siteBaseUrl: "https://compliancegenieprod-staging.azurewebsites.net"
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
